/*
BdGraph is a generic graph data structure
*/

export interface BdGraphNode {
  depth: number;
  id: string;
  boolState: {
    [key: string]: boolean;
  };
  numState: {
    [key: string]: number;
  };
}

export function BdGraphNodeFactory(id: string): BdGraphNode {
  return {
    id,
    depth: 0,
    boolState: {},
    numState: {},
  };
}

export interface BdGraph<TNode extends BdGraphNode> {
  nodes: {
    [key: string]: TNode;
  };
  successors: {
    [key: string]: string[];
  };
  predecessors: {
    [key: string]: string;
  };
  roots: {
    [key: string]: TNode;
  };
}

export function BdGraphFactory<TNode extends BdGraphNode>(): BdGraph<TNode> {
  return {
    nodes: {},
    successors: {},
    predecessors: {},
    roots: {},
  };
}

// TODO: enumerate these property names
// property-name: boolean/number state value
export class BdGraphNodeStateMap {
  [property: string]: any;
}

// node-id: NodeStateMap
export class BdGraphStateMap {
  [nodeId: string]: BdGraphNodeStateMap;
}

// node-id: boolean/number - the value of a given property for an arbitrary collection node ids
export class BdGraphPropertyValueMap {
  [nodeId: string]: any;
}

export type DoFunc = (id: string) => void;

// boolean stateful properties on our BdGraph
export class GraphNodeState {
  shown = (id) => false;
  selected = (id) => false;
  pickable = (id) => true;

  constructor(recipes: string[]) {
    // default recipe memberships to graph node state
    recipes.forEach((recipeName) => {
      this[recipeName] = (id) => false;
    });
  }
}
